import { useMatch, useNavigate } from "react-router-dom";
import { list2RoutesCombined, list3Routes, list3RoutesCombined } from "./ListAndDetailSamplesMultipleListsNavigation";
import { PageDefaultSegment, isMobileView, ListAndDetail } from "@sis/react-library";
import { list2Data, list3Data, List3ItemDto } from "./ListItemDto";
import { ListAndDetailSamplesMultipleListHeadingContainer } from "./ListAndDetailSamplesMultipleListHeadingContainer";
import { Box, Button } from "@mui/material";
import { getMatch } from "./listAndDetailSamplesMultipleListFunctions";

export const ListAndDetailSamplesMultipleList2EditPage = () => {

  const navigate = useNavigate();
  const isMobile = isMobileView();

  const matchEdit1 = useMatch(list2RoutesCombined().list_editMatch);
  const matchEdit2 = useMatch(list3RoutesCombined().list_editMatch);
  const matchNew1 = useMatch(list2RoutesCombined().new);
  const matchNew2 = useMatch(list3RoutesCombined().new);

  const match = getMatch([matchEdit1, matchEdit2, matchNew1, matchNew2]);
  const code1 = match?.params.code1;
  const code2 = match?.params.code2;

  const list2Item = list2Data.find((l1) => l1.code2 === code2);

  const handleClose = () => {
    navigate(list2RoutesCombined(code1).list);
  }

  const list3ItemRender = (item: List3ItemDto) => <>{item.description}</>;

  return (
    <ListAndDetailSamplesMultipleListHeadingContainer
      widthOffset={14}
      heading={
        <Box>
          <b>{list2Item ? `Edit item: ${list2Item.description}` : 'New item'}</b>
          <Button
            variant="contained"
            onClick={handleClose}
            sx={{ height: '24px', marginLeft: '20px' }}
          >
            Close
          </Button>
        </Box>
      }
    >
      <Box
        sx={{
          paddingTop: isMobile ? '0' : '52px',
          paddingLeft: isMobile ? '1px' : '14px',
          paddingRight: isMobile ? '1px' : undefined
        }}
      >
        {code2 &&
          <ListAndDetail
            id="list3"
            items={list3Data}
            keyValue={(item) => item.code3}
            itemRender={list3ItemRender}
            searchFields={['description']}
            listUrl={list3RoutesCombined(code1, code2).list}
            newUrl={list3Routes.new}
            editUrl={list3Routes.edit}
            reduceHeight={292} // Makes the height of the list 100vh minus this height. Defaults to 190 for PageLayoutDefault area.
          />
        }
        {!code2 &&
          <PageDefaultSegment>
            List 2 New
          </PageDefaultSegment>
        }
      </Box>
    </ListAndDetailSamplesMultipleListHeadingContainer>
  )
}
